import { render, staticRenderFns } from "./WorkItemRow.vue?vue&type=template&id=179cbebc&scoped=true"
import script from "./WorkItemRow.vue?vue&type=script&lang=js"
export * from "./WorkItemRow.vue?vue&type=script&lang=js"
import style0 from "./WorkItemRow.vue?vue&type=style&index=0&id=179cbebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179cbebc",
  null
  
)

export default component.exports